import { withModalContext } from './ModalContext';
import { withAlertContext } from './AlertContext';
import { withLoaderContext } from './LoaderContext';

function withContext(Component) {
  return withModalContext(withAlertContext(withLoaderContext(Component)));
}

export default withContext;
